define('modules/editor/behaviours/render_with_property_groups',['require','exports','module','underscore','../models/editorstate'],function(require, exports, module) {
  "use strict";

  var _ = require("underscore"),
      EditorState = require("../models/editorstate");

  module.exports = {
    _removeStyles: function(id) {
      $("#" + id).remove();
    },
    _injectStyles: function(css, id, styleId) {
      var element = document.createElement("style");
      element.id = styleId;
      element.classList.add('generated-style');
      _.each(css, function(style){
        element.innerHTML += style.selector + " {";
        element.innerHTML += _.foldl(style.rules, function(acc, v, k) {
          if (!v) { return acc; }
          return acc + "\n" + k + ":" + v + ";";
        }, "");
        element.innerHTML += "\n}\n";
      });

      document.head.appendChild(element);
    },
    _removeOldStyleTag: function(model) {
      if (!model) { return; }
      var prevId = model.previous("id"),
          id = model.get("id");
      if (prevId && prevId != id) {
        this._removeStyles("element-style-" + prevId);
      }
    },
    _propertyRender: function(func) {
      if(typeof(func) === "function"){
        func.call(this);
      }
      //console.log('PropertyRender', this.model.name);

      var id = this.model.getPropertyGroup("idclass").get("id"),
          styleId = "element-style-" + id;
      var css = _.reduce(this.model.propertyGroups, function(acc, pg) {
        pg.applyStyles(this.$el);

        //generateStyles should return an array of
        //{ selector: xxx, rules: {}}
        //in order to style child elements!!
        return _.union(acc, pg.generateStyles(this.$el, id));
      }, [], this);

      if (id) {
        this._removeStyles(styleId);
        this._injectStyles(css, id, styleId);
      }
      // _.each(this.model.propertyGroups, function(pg) {
      //   pg.applyStyles(this.$el);
      // }, this);
      // console.log(css);
      //add zIndex +1 to css to avoid being "cut" by the section borders
      if(this.model.name !== "section"){
        this.$el.css("zIndex", this.model.get("displayOrder")+1);
      } else {
        var isWide = this.model.getPropertyGroup("sectionGeometry").get("wide");
        this.$el.toggleClass("ed-hero-section", isWide);
      }
      //notify that this element has re-rendered its properties
      this.trigger("element:property:render");

      return this;
    },
    /*_spreadWide: function(view, isWider) {
      this.$el.toggleClass("ed-hero-section", isWider);
    },*/
    mixed: function(klass, proto) {
      //NOTE: try to avoid re-rendering everything unless absolutely needed
      proto.render = _.wrap(proto.render, this._propertyRender);

      proto.initialize = _.wrap(proto.initialize || identity, function(init) {
        var idclass = this.model.getPropertyGroup("idclass");
        this.listenTo(idclass, "change", this._removeOldStyleTag);
        //this.listenTo(this.model._propertyVent, "change:wide", this._spreadWide);
        this.listenTo(this.model._propertyVent, "change", this._propertyRender);
        return init.apply(this, _.rest(arguments));
      });
    }
  };
});

